<template>
    <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <md-card :style="card_bg">
            <md-card-header class="ml-2 mb-4" style="display: inline-block; background-color: rgb(0, 16, 106)">
                <p class="fs-3 mb-0" style="color: white">{{info.name}}</p>
            </md-card-header>
            <div class="container-fluid mt-2 ps-1 pe-0" >
                <div class="row ms-1 me-0">
                <div class="col-xl-3 col-lg-4 col-md-4 col-12 ps-0 fs-6 fw-bold align-items-end text-center">
                    <i class="fas fa-bolt fs-4"></i><i class="far fa-clock fs-6"></i>
                    <span>功率</span>
                </div>
                <div class="col-12 col-sm-12 col-md-auto fs-6 ps-0 align-items-end text-center">
                    <label class="fs-5 fw-bold">{{info.data.p}}</label>
                    <span class="fs-7 ms-1">W</span>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-5 col-12 ps-0 fs-6 fw-bold align-items-end text-center">
                    <font-awesome-icon class="fs-4" :icon="['fas', 'charging-station']" /><span style="font-size: 0.25rem;">Day</span>
                    <span>今日發電量</span>
                </div>
                <div class="col-12 col-sm-12 col-md-auto fs-6 ps-0 me-0 align-items-end text-center">
                    <label class="fs-5 fw-bold">{{info.data.kwh_today}}</label>
                    <span class="fs-7 ms-1">kWh</span>
                </div>
            </div>
            <!-- <table class="w-100 text-center"> 
                <tr>
                <th class="fs-5"><i class="fas fa-bolt fs-3"></i><i class="far fa-clock"></i>功率</th>
                <td class="fs-5">5<span class="fs-6 ms-1">W</span></td>
                <th class="fs-5"><i class="fas fa-bolt fs-3"></i><i class="far fa-clock"></i>今日發電量</th>
                <td class="fs-5">51111111<span class="fs-6 ms-1">kWh</span></td>
                </tr>
            </table> -->
            </div>
            <div class="container-fluid d-flex justify-content-center  p-0">
                <img src="../../assets/img/plant1.png" alt="image" class="plant_image">
            </div>

            <md-card-content class="p-0">
                <div class="container-fluid mt-4" style="color: rgb(72, 72, 72)">
                    <div class="row ms-1 ">
                        <div class="col-xxl-4 col-xl-2 col-lg-2 col-md-3 col-4 ps-0 fs-6 align-items-end ">
                            <i class="fas fa-database fs-4"></i><i class="fas fa-bolt fs-6"></i>
                            <span>案場容量</span>
                        </div>
                        <div class="col-6 col-sm-6 col-md-auto fs-6 ps-0 align-items-end">
                            <label class="fs-5 fw-bold">{{info.capacity}}</label>
                            <span class="fs-7 ms-1">kW</span>
                        </div>
                    </div>
                    <div class="row ms-1 ">
                        <div class="col-xxl-4 col-xl-2 col-lg-2 col-md-3 col-4 ps-0 fs-6 align-items-end ">
                            <i class="fas fa-location-arrow fs-4"></i><i class="fas fa-sun fs-6" style="margin-left: -5px;"></i>
                            <span>PR</span>
                        </div>
                        <div class="col-6 col-sm-6 col-md-auto fs-6 ps-0 align-items-end">
                            <label class="fs-5 fw-bold">{{info.data.PR}}</label>
                            <span class="fs-7 ms-1">%</span>
                        </div>
                    </div>
                    <div class="row ms-1 ">
                        <div class="col-xxl-4 col-xl-2 col-lg-2 col-md-3 col-4 ps-0 fs-6 align-items-end ">
                            <i class="fas fa-location-arrow fs-4"></i><i class="fas fa-sun fs-6" style="margin-left: -5px;"></i>
                            <span>DMY</span>
                        </div>
                        <div class="col-6 col-sm-6 col-md-auto fs-6 ps-0 align-items-end">
                            <label class="fs-5 fw-bold">{{info.data.DMY}}</label>
                            <span class="fs-7 ms-1">小時</span>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between mt-4">
                        <label class="fs-7">狀態：
                            <label class="text-success" v-if="info.data.led_state === 0">正常</label>
                            <label class="fs-5 fw-bold text-danger" v-else-if="info.data.led_state === 1">一級警報</label>
                            <label class="fs-5 fw-bold" v-else-if="info.data.led_state === 2" style="color: #e4ff00;">二級警報</label>
                            <label class="fs-5 fw-bold text-secondary" v-else-if="info.data.led_state === 3">設備斷線</label>
                        </label>
                        <label class="fs-7">最後更新時間：{{info.data.last_update_time}}</label>
                    </div>
                    <!-- <table class="w-100 text-center mt-4">
                    <tr>
                        <th class="fs-6">功率</th>
                        <td class="fs-5">5</td>
                        <th class="fs-6">本日最大功率</th>
                        <td class="fs-5">88.8</td>
                    </tr>
                    </table>   -->      
                </div>
            </md-card-content>
            <div class="d-flex justify-content-center" style="border-top: 1px solid #eeeeee">
                <button class="btn w-50" style="border-right: 1px solid #eeeeee" @click="more_info">更多資訊</button>   
                <!-- <button class="btn w-50" style="border-right: 1px solid #eeeeee"><router-link :to="{ name: 'User Profile', params: url_query }" >更多資訊</router-link></button> -->
                <button class="btn w-50" style="border-left: 1px solid #eeeeee" @click="to_alarm" >警報</button>
            </div>
        </md-card>
    </div>
</template>
<script>
export default {
    name: "pv-plant-card", 
    props:["info"],
    data(){
        return {
            ID: this.$vnode.key,
            url_query: {"pv_plant_ID": this.$vnode.key},
        }
    },
    methods:{
        more_info(){
            window.location.href = "plant_info?ID="+this.ID
        },
        to_alarm(){
            window.location.href = "/alarm"
        }
    },
    computed:{
        card_bg(){
            if(this.$props.info.data.led_state !== 0){
                return "background-color: #ff000033"
            }
            return ""
        },
    }
}
</script>
